import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {RichTextSchema} from '../richText'
import {safeOptional} from '../../safe-optional'
import {AssetSchema} from './asset'
import {PersonSchema} from './person'
import {TestimonialQuoteMarkColors} from '@primer/react-brand/esm'

export const PrimerComponentTestimonialSchema = buildEntrySchemaFor('primerComponentTestimonial', {
  fields: z.lazy(() =>
    z.object({
      quote: RichTextSchema,
      size: z.enum(['small', 'large']),
      variant: z.enum(['default', 'subtle', 'minimal', 'frosted-glass']).optional(),
      author: PersonSchema.optional(),
      displayedAuthorImage: z.enum(['none', 'avatar', 'logo']),
      logo: AssetSchema.optional(),
      // Entries may still use retired gradient colors, which fall back to Primer Brand's default color.
      quoteMarkColor: safeOptional(z.enum(TestimonialQuoteMarkColors)),
    }),
  ),
})

export type PrimerComponentTestimonial = z.infer<typeof PrimerComponentTestimonialSchema>

export const isPrimerTestimonial = (entry: unknown): entry is PrimerComponentTestimonial => {
  return PrimerComponentTestimonialSchema.safeParse(entry).success
}
